import { DOCUMENT } from '@angular/common'
import {
  ENVIRONMENT_INITIALIZER,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core'

const TITLE_MARK = 'data-table-ellipsis-title'

function ensureCellTitle(cell: HTMLTableCellElement): void {
  const table = cell.closest('.table-responsive > .table')
  if (!(table instanceof HTMLTableElement) || !table.tHead) return
  if (cell.closest('thead')) return
  if (cell.classList.contains('text-end') || cell.hasAttribute('nowrap')) return
  if (cell.querySelector('button, input, select, textarea, .icon-action, .btn')) return
  if (cell.getAttribute(TITLE_MARK) === '1') return

  const text = (cell.textContent ?? '').replace(/\s+/g, ' ').trim()
  if (text && text !== '-') {
    cell.title = text
  }
  cell.setAttribute(TITLE_MARK, '1')
}

/** Aplica tooltip automático em células truncadas de qualquer `.table-responsive`. */
export function provideTableEllipsis(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        const doc = inject(DOCUMENT)
        doc.addEventListener(
          'mouseover',
          (event: Event) => {
            const target = event.target
            if (!(target instanceof Element)) return
            const cell = target.closest('.table-responsive > .table:has(thead) td')
            if (!(cell instanceof HTMLTableCellElement)) return
            ensureCellTitle(cell)
          },
          true
        )
      },
    },
  ])
}
